import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

import { RootState } from "store";
import { defaultGenericMeta } from "store/common";

import {
  SchedulePayments,
  SchedulePaymentsState,
  FetchSchedulePaymentsResult
} from "./schedulePayments-state";
import {
  fetchSchedulePayments,
  updateSchedulePayments,
} from "./schedulePayments-action";

const schedulePaymentsEntityAdapter = createEntityAdapter<SchedulePayments>({});

export const schedulePaymentsSlice = createSlice({
  name: "schedulePayments",
  initialState:
    schedulePaymentsEntityAdapter.getInitialState<SchedulePaymentsState>({
      meta: { ...defaultGenericMeta },
    }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchSchedulePayments.fulfilled,
      (state, action: PayloadAction<FetchSchedulePaymentsResult>) => {
        state.meta.isLoading = false;
        state.meta.isSuccess = true;
        state.meta.status = "idle";
        const { results, ...serviceMeta } = action.payload;
        schedulePaymentsEntityAdapter.setAll(state, results);
        state.serviceMeta = serviceMeta;
      }
    );
    builder.addCase(fetchSchedulePayments.pending, (state) => {
      state.meta.isLoading = true;
      state.meta.status = "inProcess";
    });
    builder.addCase(fetchSchedulePayments.rejected, (state) => {
      state.meta.isLoading = false;
      state.meta.status = "idle";
      state.meta.error = "true";
    });
    builder.addCase(
      updateSchedulePayments.fulfilled,
      (state, action: PayloadAction<SchedulePayments>) => {
        state.meta.isLoading = false;
        state.meta.isSuccess = true;
        state.meta.status = "idle";
        if(action.payload.recurrenceScheduleId != null) {
          schedulePaymentsEntityAdapter.updateOne(state, {
            id: action.payload.id,
            changes: {
              status: action.payload.status
            }
          });
        }
        else {
          schedulePaymentsEntityAdapter.removeOne(state, action.payload.id);
        }
      }
    );
    builder.addCase(updateSchedulePayments.pending, (state) => {
      state.meta.isLoading = true;
      state.meta.status = "inProcess";
    });
    builder.addCase(updateSchedulePayments.rejected, (state) => {
      state.meta.isLoading = false;
      state.meta.status = "idle";
      state.meta.error = "true";
    });
  },
});

export const { selectAll: selectAllschedulePayments } =
  schedulePaymentsEntityAdapter.getSelectors(
    (state: RootState) => state.schedule
  );

export default schedulePaymentsSlice.reducer;
